export enum ErrorType {
    Generic = 'Generic',
};